import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useHistory } from 'react-router'
import { DatePicker, SelectBox, TextInput } from '@tecuity/granite-ui'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import {
  GetBatchTypes,
  GetPostDistributions,
  GetReports,
  Post,
  GetDistReports,
} from './PostDistributionActions'
import CalendarIcon from '@tecuity/sos-icons/react/calendar'
import format from 'date-fns/format'
import StepButton from '../StepButton'

const PostDistributions = () => {
  const [showThroughDate, setShowThroughDate] = useState(false)
  const [selectedOption, setOptionSelected] = useState(false)
  const [selectedBatchType, setBatchTypeSelected] = useState(null)
  const [throughDate, setThroughDate] = useState(format(new Date(), 'MM/dd/yyyy'))
  const [sumTotal, setSumTotal] = useState(0)
  const [step, setStep] = useState(1)
  const { batchTypes, payments, reports, batchNum } = useSelector(
    (state) => state.postDistributions,
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const [selectedRows /*setSelectedRows*/] = useState([])
  const tableColumnsPayments = [
    { field: 'type', flex: 0.5, minWidth: 60, headerName: 'Payment Type', disableColumnMenu: true },
    { field: 'count', flex: 0.2, minWidth: 60, headerName: 'Count', disableColumnMenu: true },
    {
      field: 'amount',
      flex: 0.2,
      minWidth: 60,
      headerName: 'Amount',
      disableColumnMenu: true,
      renderCell: (params) => {
        return `$${(params.row.amount || 0)
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      },
    },
  ]

  const tableColumnsReports = [
    {
      field: 'displayName',
      flex: 0.75,
      minWidth: 60,
      headerName: 'Reports to Print',
      disableColumnMenu: true,
    },
  ]

  useEffect(() => {
    dispatch(GetBatchTypes())
    dispatch(GetReports())
  }, [])

  useEffect(() => {
    let total = 0
    payments.forEach((payment) => {
      total += parseFloat(payment.amount)
    })
    setSumTotal(total.toFixed(2))
  }, [payments])

  useEffect(() => {
    if (selectedBatchType) {
      dispatch(GetPostDistributions(selectedBatchType, throughDate))
    }
  }, [throughDate])

  const postDistributions = () => {
    dispatch(Post(selectedBatchType, throughDate))
    setStep(2)
  }

  useEffect(() => {
    if (batchNum) {
      dispatch(GetDistReports(batchNum))
    }
  }, [batchNum])

  return (
    <React.Fragment>
      <h2 className="accounting-form-header">Post Distributions</h2>

      <div className="reconcile-wrapper">
        <div className="steps-sidebar">
          <StepButton
            active={step === 1}
            isValid={step > 1 ? true : undefined}
            title="Select Payments"
            stepIndex={1}
            totalSteps={2}
            setStep={1}
          />
          <StepButton
            active={step === 2}
            isValid={step > 1 ? true : undefined}
            title="Print Reports"
            stepIndex={2}
            totalSteps={2}
            setStep={1}
          />
        </div>
        <div className="form-wrapper">
          {step == 1 && (
            <SelectBox
              label="Batch Type"
              customCss="max-width: 250px"
              onChange={(e) => {
                setOptionSelected(true)
                dispatch(GetPostDistributions(e, throughDate))
                setBatchTypeSelected(e)
              }}
              options={batchTypes}
              noPlaceholder={selectedOption}
            />
          )}
          {step == 1 && (
            <div className="date-picker-holder">
              <TextInput
                label={'Batches Created Through'}
                placeholder="MM/DD/YYYY"
                customCss="max-width: 250px"
                onChange={(e) => {
                  setThroughDate(e.target.value)
                }}
                value={throughDate}
              />
              <button
                className={`btn btn-primary picker-button`}
                aria-label={`Open calendar widget for Through Date`}
                onClick={() => setShowThroughDate(true)}
                style={{ marginTop: '14px' }}
              >
                <CalendarIcon size="small" />
              </button>
              <DatePicker
                isOpen={showThroughDate}
                onChange={(e) => {
                  setThroughDate(format(new Date(e), 'MM/dd/yyyy'))
                  setShowThroughDate(false)
                }}
                onCalendarClose={() => {
                  setShowThroughDate(false)
                }}
              />
            </div>
          )}
          <div className='accounting-table'>
            <GraniteDataGrid
              columns={step == 1 ? tableColumnsPayments : tableColumnsReports}
              rows={step == 1 ? payments : reports}
              pagination={undefined}
              rowsPerPageOptions={[25, 50, 100]}
              checkboxSelection={false}
              selectionModel={selectedRows}
            />
            <h2>Sum Total: {sumTotal}</h2>
          </div>
        </div>
      </div>

      <div className="context-bar-wrapper">
        <ContextBar>
          <ContextButton variant="secondary" onClick={() => history.push('/accounting')}>
            {step == 1 ? 'Cancel' : 'Close'}
          </ContextButton>
          {step === 1 && (
            <ContextButton
              variant="primary"
              onClick={() => {
                postDistributions()
              }}
              disabled={step === 1 ? !(payments.length > 0) : false}
            >
              {'Post Distributions'}
            </ContextButton>
          )}
        </ContextBar>
      </div>
    </React.Fragment>
  )
}

export default PostDistributions
